import { reverse } from 'named-urls'
import React from 'react'

import { Avatar, ButtonClean, Skeleton } from '@fourthwall/components'
import { routing } from '@utils/routing'

import { EventsSection } from '../../components/EventsSection/EventsSection'
import { useOverviewContext } from '../../hooks/useOverviewContext'
import { getJoinedDate } from '../../utils'
import * as S from './styled'

export const NewMembers = () => {
  const overview = useOverviewContext()

  if (overview.isLoading || overview.newMembers === null) {
    return (
      <Skeleton>
        <Skeleton.Shape width="100%" height={256} />
      </Skeleton>
    )
  }

  return (
    <EventsSection
      title="Newest members"
      button={
        <S.ButtonContainer>
          <ButtonClean
            label="See all"
            appearance="secondary"
            to={overview.newMembers.length > 0 ? routing.memberships.members.self : undefined}
            withUnderline={false}
            disabled={!overview.newMembers.length}
          />
        </S.ButtonContainer>
      }
      emptyMessage={
        overview.newMembers.length === 0 ? "You don't have any members yet." : undefined
      }
    >
      <S.Container>
        {overview.newMembers.map(({ id, avatarUrl, joinedAt, nickname, tierName }) => {
          return (
            <S.Member to={reverse(routing.memberships.members.member.self, { memberId: id })}>
              <S.JoinedDate>{getJoinedDate(joinedAt)}</S.JoinedDate>
              <S.MemberDetails>
                <S.AvatarContainer>
                  <Avatar name={nickname} imageUrl={avatarUrl} size="small" />
                </S.AvatarContainer>
                <S.Nickname>{nickname}</S.Nickname>
              </S.MemberDetails>
              <S.Tier>{tierName}</S.Tier>
            </S.Member>
          )
        })}
      </S.Container>
    </EventsSection>
  )
}
